/**
 * Content Tile
 */
import { Component, registerComponent } from 'js/component.js';
import { formatIsoDateTime } from 'js/helpers.js';

const componentName = 'content-tile';

export class ContentTile extends Component {
    /** Component elements */
    elements = {
        webinarDetails: this.element.querySelector(`.${componentName}__webinar-details`),
        webinarDateItem: this.element.querySelector(`.${componentName}__webinar-detail.startDate`),
        webinarTimeItem: this.element.querySelector(`.${componentName}__webinar-detail.startTime`)
    };

    /** Initialize components */
    init() {
        if (this.elements.webinarDetails != null) {
            const eventStart = this.elements.webinarDetails.dataset.startTime;
            const eventEnd = this.elements.webinarDetails.dataset.endTime;

            const {
                startDate, startTime, timeZoneLong
            } = formatIsoDateTime(eventStart, eventEnd);

            // Inject date and time formats to match locale of current site
            const dateContent = this.elements.webinarDateItem.innerHTML;
            const timeContent = this.elements.webinarTimeItem.innerHTML;
            const dateLabel = dateContent.substring(0, dateContent.lastIndexOf('/span>') + 6);
            const timeLabel = timeContent.substring(0, timeContent.lastIndexOf('/span>') + 6);

            this.elements.webinarDateItem.innerHTML = `${dateLabel} ${startDate}`;
            this.elements.webinarTimeItem.innerHTML = `${timeLabel} ${startTime} ${timeZoneLong}`;
        }
    }
}

registerComponent(`.${componentName}`, ContentTile);
